import { Typography, Paper, Stack } from '@mui/material';

import ResetPassword from './customerUserInfo/resetPassword';
import UpdateEmail from './customerUserInfo/updateEmail';

import { TextStyle } from '../../../assets/styles/custom.styles';
import { getLastActiveTime } from '../../../assets/utils/helpers';
import { TenantUserDetailObject } from '../../../Page/customer/partner/customer/customerUserInfoPage';
import LoadingComponent from '../../common/loadingComponent';

interface CustomerUserDetailsProps {
  isLoading: boolean;
  isError: boolean;
  errorText: string;
  data: TenantUserDetailObject;
  updateEmail: (email: string) => void;
}

const container = {
  border:'1px solid rgba(0, 0, 0, 0.16)',
  borderRadius: '8px',
  maxWidth: '100%',
};

const indicatorText = {
  color: '#878787',
  fontStyle: 'normal',
  fontSize: '16px',
  fontWeight: 400, 
  lineHeight: 'normal',
  minWidth: '168px',
};
const bodyText = {
  color: '#181818',
  fontStyle: 'normal',
  fontSize: '16px',
  fontWeight: 400, 
  lineHeight: 'normal',
};
const CustomerUserInfo = ({ isLoading, isError, errorText, data, updateEmail }: CustomerUserDetailsProps) => {
  
  return (
    <Paper sx={container}>
      <Typography sx={{
        ...TextStyle.headerText, 
        padding: '1.5rem 1.25rem' }}
      >User Information
      </Typography>
      {isLoading && <LoadingComponent isMinHeight/>}
      {!isLoading && !isError &&
        <Stack 
          spacing={5}
          sx={{
            padding: '0rem 1.25rem 1.5rem 1.25rem', 
          }}>
          <Stack direction='row'>
            <Typography sx={indicatorText}>User Role:</Typography>
            <Typography sx={bodyText}>{data.tenantUserRole}</Typography>
          </Stack>
          <Stack direction='row'>
            <Stack>
              <Typography sx={indicatorText}>Date Registered:</Typography>
              <Typography sx={{
                ...indicatorText,
                fontSize: '14px',
              }}>(mm,dd,yyyy)</Typography>
            </Stack>
            <Typography sx={bodyText}>{
              data.dateRegistered == null ?
                'none'
                :
                new Date(data.dateRegistered).toLocaleString([], { month: 'long', day: '2-digit', year: 'numeric' })}</Typography>
          </Stack>
          <Stack direction='row'>
            <Typography sx={indicatorText}>Email:</Typography>
            <Typography sx={bodyText}>{data.email}</Typography>
          </Stack>
          <Stack direction='row'>
            <Typography sx={indicatorText}>Contact Number:</Typography>
            <Typography sx={bodyText}>{data.contactNumber ?? 'none'}</Typography>
          </Stack>
          <Stack direction='row'>
            <Typography sx={indicatorText}>2 Factor Status:</Typography>
            <Typography sx={bodyText}>{data.mfaStatus ? 'On' : 'Off'}</Typography>
          </Stack>
          <Stack direction='row'>
            <Typography sx={indicatorText}>TOTP Status:</Typography>
            <Typography sx={bodyText}>{data.totpStatus ? 'On' : 'Off'}</Typography>
          </Stack>
          <Stack direction='row'>
            <Typography sx={indicatorText}>Last Active:</Typography>
            <Typography sx={bodyText}>{getLastActiveTime(data.lastActive)}</Typography>
          </Stack>
          <ResetPassword currEmail = {data.email}/>
          <UpdateEmail updateEmail = {updateEmail}/>
        </Stack>
      }
      {!isLoading && isError &&
          <Typography sx={{
            textAlign: 'center',
            padding:'40px',
            color:'#FF5E56',
          }}>{errorText}</Typography>
      }
    </Paper>
  );
};

export default CustomerUserInfo;
